import {
  ETableActiveItem,
  ETableCellObject,
  ETableRowID,
  ETableSort,
  isActiveRowChildItem,
} from './types';

/**
 * Validates whether two given ordering arrays are identical (i.e. same number of array items, and
 * identical property values). Can be used to avoid rerender loops.
 */
export const isOrderIdentical = (
  order1: ETableSort<string> | undefined,
  order2: ETableSort<string> | undefined
): boolean => {
  if (!order1 && !order2) {
    return true;
  }
  if (order1 && order2 && order1.length === order2.length) {
    return order1.every((o1, index) => {
      const o2 = order2[index]!;
      return o1.columnName === o2.columnName && o1.order === o2.order;
    });
  }
  return false;
};

/**
 * Returns whether the given item is either one of
 * - is active itself
 * - has an active child (i.e. nested) item
 * - is an active child (i.e. nested) item
 */
export const isActiveItem = (
  itemId: ETableRowID,
  activeItem: ETableActiveItem | undefined
): boolean =>
  activeItem && isActiveRowChildItem(activeItem)
    ? itemId === activeItem.parentId || itemId === activeItem.childId
    : itemId === activeItem;

/** Verifies whether the passed active items are identical, either by reference or by (deep) value. */
export const isEqualActiveItem = (
  activeItem: ETableActiveItem | undefined,
  userActiveItem: ETableActiveItem | undefined
): boolean =>
  activeItem === userActiveItem ||
  (isActiveRowChildItem(activeItem) &&
    isActiveRowChildItem(userActiveItem) &&
    activeItem.parentId === userActiveItem.parentId &&
    activeItem.childId === userActiveItem.childId);

export const blankTableCell: ETableCellObject = {
  cell: '',
  styleType: 'hide-border-bottom',
};
